import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import Plyr from "plyr";
import PhotoSwipe from "photoswipe";

const initializeVideoCarousels = () => {
  const carousels = document.querySelectorAll(".video-carousel-swiper");

  if (!carousels.length) {
    return;
  }

  carousels.forEach((carouselElement) => {
    const container = carouselElement.closest(
      ".video-carousel-swiper-container"
    );
    if (!container) return;

    new Swiper(carouselElement, {
      modules: [Navigation, Pagination],
      loop: false,
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: container.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: container.querySelector(".swiper-button-next"),
        prevEl: container.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });

    // Lightbox Logic (adapted from mediaShowcase.js)
    let activePlyrInstance = null;

    const destroyActivePlayer = () => {
      if (activePlyrInstance) {
        try {
          activePlyrInstance.destroy();
          activePlyrInstance = null;
        } catch (e) {
          // console.error("Error destroying Plyr instance:", e);
        }
      }
    };

    carouselElement.addEventListener("click", (e) => {
      const clickedItem = e.target.closest(".video-carousel-item");
      if (!clickedItem) {
        return;
      }
      e.preventDefault();

      const items = Array.from(
        carouselElement.querySelectorAll(".video-carousel-item")
      );
      const clickedIndex = items.findIndex((item) => item === clickedItem);

      // We only have videos, so the dataSource is simpler
      const dataSource = items.map((item) => {
        const videoUrl = item.dataset.videoUrl;
        return {
          html: `<div class="pswp__video-container"><div class="plyr__video-embed js-plyr-player"><iframe src="${videoUrl}?origin=https://player.vimeo.com&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1" allowfullscreen allowtransparency allow="autoplay"></iframe></div></div>`,
          type: "video",
        };
      });

      const pswp = new PhotoSwipe({
        dataSource: dataSource,
        index: clickedIndex,
        pswpModule: PhotoSwipe,
      });

      pswp.on("change", () => {
        destroyActivePlayer();
        const currentSlide = pswp.currSlide;
        if (currentSlide.data.type === "video") {
          const playerWrapper =
            currentSlide.content.element.querySelector(".js-plyr-player");
          if (playerWrapper) {
            activePlyrInstance = new Plyr(playerWrapper);

            // Prevent PhotoSwipe from hijacking pointer events on Plyr controls
            activePlyrInstance.on("ready", (event) => {
              const controls = event.detail.plyr.elements.controls;
              if (controls) {
                controls.addEventListener("pointerdown", (e) => {
                  e.stopPropagation();
                });
              }
            });

            setTimeout(() => {
              if (activePlyrInstance) activePlyrInstance.play();
            }, 300);
          }
        }
      });

      pswp.on("close", () => {
        destroyActivePlayer();
      });

      pswp.init();
    });
  });
};

document.addEventListener("DOMContentLoaded", initializeVideoCarousels);
if (document.readyState !== "loading") {
  initializeVideoCarousels();
}
